import { createSignal, onCleanup, onMount, Show } from "solid-js";

export const Loader = (props: { message?: string }) => (
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <div class="small fw-medium text-muted">{props.message || 'Chargement en cours...'}</div>
  </div>
);

export const NavDropdown = (props: { label: any; icon?: string; children?: any }) => {
  const [showMenu, setShowMenu] = createSignal(false);
  let menuContainer: HTMLElement;

  const handleDocumentClick = (event: MouseEvent) => {
    if (menuContainer && !menuContainer.contains(event.target as Node)) {
      setShowMenu(false);
    }
  };

  onMount(() => {
    document.addEventListener('click', handleDocumentClick);
  });
  onCleanup(() => {
    document.removeEventListener('click', handleDocumentClick);
  });

  return (
    <li ref={menuContainer!} class={"nav-item dropdown " + (showMenu() ? 'show' : '')}>
      <a
        class={"nav-link dropdown-toggle " + (showMenu() ? 'show' : '')}
        href="#"
        role="button"
        onClick={(e) => {
          e.preventDefault();
          setShowMenu(!showMenu());
        }}
        aria-expanded={showMenu()}
      >
        <Show when={props.icon}>
          <i class={`bi ${props.icon} me-1`}></i>
        </Show>
        {props.label}
      </a>
      <ul
        class={"dropdown-menu dropdown-menu-end shadow-sm " + (showMenu() ? 'show' : '')}
        onClick={() => setShowMenu(false)}
      >
        {props.children}
      </ul>
    </li>
  );
};
